import moment from "moment-timezone";

// Convert any single digit number in two digit number
export const twoDigit = (n) => {
  return n < 10 ? "0" + n : n;
};

// Add days to a given date
export const addDays = (date, noOfDays) => {
  let actualDate = new Date(date);
  let newDate = new Date(
    actualDate.getFullYear(),
    actualDate.getMonth(),
    actualDate.getDate() + noOfDays
  );
  newDate = moment.tz(newDate, "Asia/Kolkata").format();
  return newDate;
};

// Return formatted date
export const getFormatedDate = (date, formatText = "DD MMM YY") => {
  let actualDate = new Date(date);
  actualDate = moment.tz(actualDate, "Asia/Kolkata").format(formatText);

  return actualDate;
};

// Return formatted date with time
export const getFormatedDateTime = (date) => {
  let actualDate = new Date(date);
  actualDate = moment.tz(actualDate, "Asia/Kolkata").format("DD-MMM-YY HH:mm");

  return actualDate;
};

// Return formatted time
export const getFormatedTime = (value, formatString) => {
  var formatted = moment.utc(value * 1000).format(formatString);
  return formatted;
};

// Convert Minutes to Seconds
export const convertMinToSecond = (minString) => {
  var minString = minString.split(":");
  var mintosec = Number(minString[0]) * 60;
  var seconds = mintosec + Number(minString[1]);
  return +seconds;
};

export const currentMonth = (formatTxt = "DD-MMM-YYYY") => {
  let startOfMonth = moment().startOf("month").format(formatTxt);
  let endOfMonth = moment().endOf("month").format(formatTxt);
  let newObj = Object();
  newObj.startOfMonth = startOfMonth;
  newObj.endOfMonth = endOfMonth;
  return newObj;
};

// Convert Minutes to Seconds
export const convertSecondToMin = (secString) => {
  return `${twoDigit(Math.floor(+secString / 60))}:${twoDigit(
    (+secString % 60).toFixed(0)
  )}`;
};

export const getByMonth = (monthId, formatTxt = "DD-MMM-YYYY") => {
  let currentYear = moment().year();

  // months start at index 0 in momentjs, so we subtract 1
  let startOfMonth = moment([currentYear, monthId, 1]).format(formatTxt);
  // get the number of days for this month
  let daysInMonth = moment(startOfMonth).daysInMonth();
  // we are adding the days in this month to the start date (minus the first day)
  let endOfMonth = moment(startOfMonth)
    .add(daysInMonth - 1, "days")
    .format(formatTxt);

  let newObj = Object();
  newObj.startOfMonth = startOfMonth;
  newObj.endOfMonth = endOfMonth;
  return newObj;
};

export const fancyTimeFormat = (ms) => {
  if (ms == 0 || ms == undefined || ms == null) return "00:00";
  let min = Math.floor((ms / 1000 / 60) << 0);
  let sec = Math.floor((ms / 1000) % 60);
  return twoDigit(min) + ":" + twoDigit(sec);
};

export const chartTimeFormat = (ms) => {
  let min = Math.floor((ms / 1000 / 60) << 0);
  let sec = Math.floor((ms / 1000) % 60);
  let rs = min + "." + twoDigit(sec);
  rs = parseFloat(rs);
  return rs;
};

export const fancyTimeHhMmSs = (ms, format = "HH:MM:SS") => {
  if (ms == 0 || ms == undefined || ms == null) {
    if (format == "MM:SS") {
      return "00:00";
    } else {
      return "00:00:00";
    }
  }
  let hrs = Math.floor((ms / (1000 * 60 * 60)) << 0);
  let min = Math.floor((ms / (1000 * 60)) % 60);
  let sec = Math.floor((ms / 1000) % 60);
  if (format == "MM:SS") {
    if (hrs > 0) {
      return twoDigit(hrs) + ":" + twoDigit(min) + ":" + twoDigit(sec);
    } else {
      return twoDigit(min) + ":" + twoDigit(sec);
    }
  } else {
    return twoDigit(hrs) + ":" + twoDigit(min) + ":" + twoDigit(sec);
  }
};

export const getByWeekDate = (subDays = 0, formatTxt = "DD-MMM-YYYY") => {
  let currentDate = moment().format(formatTxt);
  let endDate = moment().subtract(subDays, "days").format(formatTxt);

  let newObj = Object();
  newObj.startOfWeek = endDate;
  newObj.endOfWeek = currentDate;
  return newObj;
};

// Return formatted date
export const getTimeStamp = (date) => {
  let actualDate = new Date(date);
  actualDate = moment.tz(actualDate, "Asia/Kolkata").format();
  actualDate = new Date(actualDate);
  return actualDate.getTime();
};

// Return formatted time only
export const getFormatedTimeOnly = (date, formatText = "HH:mm") => {
  let actualDate = new Date(date);
  actualDate = moment.tz(actualDate, "Asia/Kolkata").format(formatText);

  return actualDate;
};

// Return formatted time only
export const getDaysDiff = (date1, date2) => {
  let date1Obj = moment.tz(date1, "Asia/Kolkata");
  let date2Obj = moment.tz(date2, "Asia/Kolkata");
  let diffOfDays = date2Obj.diff(date1Obj, "days");

  return diffOfDays;
};

// Return formatted date
export const getBroadCastFolderDates = (date) => {
  let dateFldName = moment.tz(date, "Asia/Kolkata").format("DDMMYYYY");

  return dateFldName;
};

// Add days to a given date
export const addDaysWithFormat = (date, noOfDays, formatText = "DD-MMM-YY") => {
  let actualDate = new Date(date);
  let newDate = new Date(
    actualDate.getFullYear(),
    actualDate.getMonth(),
    actualDate.getDate() + noOfDays
  );
  console.log("actualDate", actualDate);
  newDate = moment.tz(newDate, "Asia/Kolkata").format(formatText);
  return newDate;
};

export const orderByTime = (data, type = "asc") => {
  return data.sort((a, b) => {
    if (type == "asc")
      return moment
        .tz(a.attempttime, "Asia/Kolkata")
        .diff(moment.tz(b.attempttime, "Asia/Kolkata"));
    else
      return moment
        .tz(b.attempttime, "Asia/Kolkata")
        .diff(moment.tz(a.attempttime, "Asia/Kolkata"));
  });
};
